import React from "react";

import { CookieLawButton } from "@brexhq/next/src/components/shared/Link/FooterLink";
import { Link } from "@brexhq/next/src/components/shared/Link/Link";

import { ICookieLink, IFooterLink } from "./types";

export const FooterLink: React.FC<IFooterLink | ICookieLink> = (linkData) => {
  const { text, cookiePopup } = linkData;
  return cookiePopup ? (
    <CookieLawButton
      onClick={() => globalThis?.transcend?.showConsentManager?.()}
    >
      {text}
    </CookieLawButton>
  ) : (
    <Link
      section={text.replace(" ", "").toLowerCase()}
      component="footer"
      to={
        linkData.link.to ||
        linkData.link.toExternal ||
        linkData.link.hash ||
        "#"
      }
      noFollow={linkData.link.noFollow}
      label={text}
      modifier="footer"
    />
  );
};
